import Vue from 'vue';
import VueRouter from 'vue-router';
// import { isProdEnv } from "@/utils/index";

// main layout
import Layout from '@/components/layout/layout.vue';
import mapLayout from '@/components/layout/mapLayout.vue';

// import TreatureBox from "@aibee/admin-business-components";
// import "@aibee/admin-business-components/lib/admin-business-components.css";

// const { PlaceList, PlaceAdd, setHostEnv } = TreatureBox;
// if (isProdEnv()) {
//   setHostEnv("prod");
// } else {
//   setHostEnv("test");
// }

// Vue.use(PlaceList);
// Vue.use(PlaceAdd);
Vue.use(VueRouter);

const routes = [
  {
    path: '/place',
    redirect: '/place/list',
    meta: { title: '场管理', icon: 'place' },
    component: Layout,
    children: [
      {
        path: 'list',
        name: 'place.list',
        component: () => import('@/views/place/list.vue'),
        meta: { title: '场列表' },
      },
      {
        path: 'add',
        name: 'place.add',
        component: () => import('@/views/place/add.vue'),
        meta: { title: '场管理' },
        hidden: true,
      },
      {
        path: 'pkg',
        name: 'place.pkg',
        component: () => import('@/views/offline/index.vue'),
        meta: { title: '离线包管理' },
        hidden: false,
      },
      {
        path: '/map',
        // redirect: '/map/mapAlign/2d',
        // hidden: true,
        meta: { title: '地图管理' },
        component: mapLayout,
        children: [
          {
            path: 'mapAlign/:source',
            name: 'map.mapAlign',
            meta: {
              title: '地图管理',
            },
            component: () => import('@/views/mapTools/mapAlign.vue'),
          },
          {
            path: 'mapLabel/:source',
            name: 'map.mapLabel',
            hidden: true,
            meta: {
              title: '地图管理',
            },
            component: () => import('@/views/mapTools/mapLabel.vue'),
          },
          {
            path: 'mapRouter/:source',
            name: 'map.mapRouter',
            hidden: true,
            meta: {
              title: '路网管理',
            },
            component: () => import('@/views/mapTools/mapRouter.vue'),
          },
          {
            path: 'mapLiveAction/:source',
            name: 'map.mapLiveAction',
            hidden: true,
            meta: {
              title: '地图实景',
            },
            component: () => import('@/views/mapTools/mapLiveAction.vue'),
          },
          {
            path: 'uploadfile',
            name: 'map.uploadfile',
            hidden: true,
            meta: {
              title: '上传文件',
            },
            component: () => import('@/views/mapTools/mapUploader.vue'),
          },
          {
            path: 'leicaAlign',
            name: 'map.leicaAlign',
            hidden: true,
            meta: {
              title: '莱卡图对齐',
            },
            component: () => import('@/views/mapTools/mapImageAlign/index.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/map/newMapRouter',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/mapTools/newMapRouter.vue'),
    hidden: true,
  },
  {
    path: '/map/scopeLabeling',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/mapTools/scopeLabeling'),
    hidden: true,
  },
  {
    path: '/map/vrUpdate',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/mapTools/vrUpdate/index.vue'),
    hidden: true,
  },
  {
    path: '/map/gisMapRouter',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/mapTools/gisMapRouter.vue'),
    hidden: true,
  },
  {
    path: '/login',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  {
    path: '/register',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/login/register'),
    hidden: true,
  },
  {
    path: '/modifyPassword',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/login/modify-password'),
    hidden: true,
  },
  {
    path: '/admin',
    meta: { title: '后台管理', icon: 'rule' },
    component: Layout,
    children: [
      {
        path: 'user',
        name: 'user',
        // eslint-disable-next-line import/no-unresolved
        component: () => import('@/views/admin/user/index.vue'),
        meta: { title: '用户管理' },
      },
      {
        path: 'user-group',
        name: 'user-group',
        // eslint-disable-next-line import/no-unresolved
        component: () => import('@/views/admin/user-group/index.vue'),
        meta: { title: '用户组管理' },
      },
      {
        path: 'auth-group',
        name: 'auth-group',
        // eslint-disable-next-line import/no-unresolved
        component: () => import('@/views/admin/auth-group/index.vue'),
        meta: { title: '权限管理' },
      },
      {
        path: 'place-group',
        name: 'admin.place',
        component: () => import('@/views/admin/place-group/index.vue'),
        meta: { title: '场权限管理' },
      },
      {
        path: 'place-group-edit',
        name: 'admin.place.edit',
        hidden: true,
        component: () => import('@/views/admin/place-group/edit.vue'),
        meta: { title: '场用户管理' },
      },
    ],
  },
  {
    path: '/project',
    redirect: '/project',
    meta: { title: '项目管理', icon: 'project' },
    component: Layout,
    children: [
      {
        path: '/project',
        name: 'project',
        component: () => import('@/views/project/project.vue'),
        meta: { title: '项目管理' },
      },
      {
        path: '/add-project',
        name: 'add-project',
        hidden: true,
        component: () => import('@/views/project/addProject.vue'),
        meta: { title: '项目管理' },
      },
    ],
  },
  {
    path: '/devices',
    redirect: '/devices',
    meta: { title: '设备管理', icon: 'devices' },
    component: Layout,
    children: [
      {
        path: '/devices',
        name: 'devices',
        component: () => import('@/views/devices/devices.vue'),
        meta: { title: '设备管理' },
      },
      {
        path: '/devicesDetails/:id/:deployId',
        name: 'devicesDetails',
        hidden: true,
        component: () => import('@/views/devices/devicesDetails.vue'),
        meta: { title: '摄像头详情' },
      },
    ],
  },
  {
    path: '/bluetooth',
    redirect: '/bluetooth',
    meta: { title: '蓝牙5.1', icon: 'route' },
    component: Layout,
    children: [
      {
        path: '/bluetooth',
        name: 'bluetooth',
        component: () => import('@/views/bluetooth/index.vue'),
        meta: { title: '蓝牙5.1' },
      },
      {
        path: '/bluetooth/form',
        name: 'form',
        hidden: true,
        component: () => import('@/views/bluetooth/form.vue'),
        meta: { title: '报表' },
      },
      {
        path: '/bluetooth/tool',
        name: 'tool',
        hidden: true,
        component: () => import('@/views/bluetooth/tool.vue'),
        meta: { title: '工具' },
      },
    ],
  },
  {
    path: '/workbench',
    redirect: '/workbench/index',
    meta: { title: '工作台', icon: 'workbench' },
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'workbench',
        component: () => import('@/views/workbench/index.vue'),
        meta: { title: '工作台' },
      },
    ],
    hidden: true,
  },
  {
    path: '/deploy',
    redirect: '/deploy/index',
    meta: { title: '部署', icon: 'deploy' },
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'deploy',
        component: () => import('@/views/deployPage/Deploy.vue'),
        meta: { title: '部署' },
      },
    ],
  },
  { path: '*', redirect: '/place', hidden: true },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.params.source && to.params.source === ':source') {
    to.params.source = 'cad';
    next({ path: '/map/mapAlign/2d' });
  } else {
    next();
  }
});
export default router;
